import { Objectclass } from '@yes.technology/react-toolkit'
import { useEffect } from 'react'
import { useSiteState } from 'siteState/shared'

export type UseFilterObjectclassSyncParams = {
  objectclass: Objectclass | undefined
}

export const useFilterObjectclassSync = ({
  objectclass
}: UseFilterObjectclassSyncParams): void => {
  const [, setFilterObjectclass] = useSiteState<Objectclass | undefined>(
    'filter-objectclass'
  )

  useEffect(() => {
    setFilterObjectclass(objectclass)
  }, [objectclass, setFilterObjectclass])
}
